import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Manutenção de Alocações — Administração → Ferramentas, só suporte (o servidor confere a sessão
 * em toda rota). Corrige o que a tela de alocação do legado deixou: duplicidades, histórico,
 * vínculos, posição. Ver docs/manutencao-alocacoes/README.md.
 */
export default [
  {
    description: 'Manutenção de Alocações',
    path: '/administracao/manutencao-alocacoes',
    name: 'manutencao_alocacoes',
    component: () => import('@/views/administracao/manutencaoalocacoes/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.MANUTENCAODEALOCACOESNOVO_MENU_2200101702],
    },
    goesToMenu: true,
  },
];
